import crud from '@/crud/index/index'
import resources from '../../resources'
import computed from './computed'

export default {
  mixins: [crud, resources],
  computed
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/index/resources/index.js